import { render, staticRenderFns } from "./pois.vue?vue&type=template&id=7c858adf&scoped=true&"
import script from "./pois.vue?vue&type=script&lang=js&"
export * from "./pois.vue?vue&type=script&lang=js&"
import style0 from "./pois.vue?vue&type=style&index=0&id=7c858adf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c858adf",
  null
  
)

export default component.exports